import type { SupabaseClient } from '@supabase/supabase-js';

import { getSupabaseBrowser } from '@/lib/supabase/browser';

// Backwards-compatible export for client-side usage.
export function createClient(): SupabaseClient<any, any, any> {
  return getSupabaseBrowser();
}
